import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import OneTaskEnd from './OneTaskEnd';
import { ipAddress } from '../../ipAddress';


interface Task {
    name: string,
    id: number,
    isDone: number,
    dateEnd: string,
    toDoGroupId: number
}


const OneGroupTasksEnd: React.FC = () => {

    const [allTasksDone, setAllTasksDone] = useState<Task[]>([]);


    const location = useLocation();
    const [nameGroup, setNameGroup] = useState<string>('');
    const [idGroup, setIdGroup] = useState<number>(0);

    const navigate = useNavigate();


    useEffect(() => {
        if (location.state) {
            let dane = location.state as any;
            let dane2 = dane.from;
            //setDataGroup([...dataGroup, { id: dane2.id, name: dane2.name }])
            //{dataGroup[0].id} w div
            // Dopiero za 2 razem widzi dane i daje błąd undefined
            setNameGroup(dane2[0])
            setIdGroup(dane2[1])

        }
    }, [location])



    // Download Tasks 
    const downloadTasksDone = () => {
        axios.post(ipAddress + '/getTasksDone', {
            toDoGroupId: idGroup,
        })
            .then(response => {
                setAllTasksDone(response.data);

            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        downloadTasksDone();
    }, [allTasksDone])


    for (let i = 0; i < allTasksDone.length; i++) {
        var date2 = new Date();
        let date1 = new Date(allTasksDone[i].dateEnd);
        //var dateFormart = new Date(`"${month}/${day}/${year}"`);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)); 
        if(diffDays > 7 ){
          axios.post(ipAddress + "/deleteTask", {
              id: allTasksDone[i].id
            })
            
            
        }
    
      }


    return (
        <div className='oneGroup'>
            <div className='title'>
                <Link to='/ToDo'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>

                <span id='title'> {nameGroup}</span>
            </div>
            <div className='toDoTaskEnd'>
                <a id='back' onClick={() => navigate(-1)}>Zaplanowane</a>
                <Link to='/ToDo/One/Zakonczone'>Zakończone</Link>
            </div>

            <Outlet />


            <div>{
                allTasksDone.map((task) => (
                    <OneTaskEnd task={task} key={task.id} />
                )

                )
            }</div>

        </div>
    )

}

export default OneGroupTasksEnd